{
  "anonymousConsents": {
    "preferences": "Consent Preferences",
    "dialog": {
      "title": "Consent Management",
      "legalDescription": "We use cookies/browser's storage to personalize the content and improve user experience. We also might share the data about your site usage with our social media. For more, please review our privacy policy.",
      "selectAll": "Select all",
      "clearAll": "Clear all"
    },
    "banner": {
      "title": "This website uses cookies",
      "description": "We use cookies/browser's storage to personalize the content and improve user experience.",
      "allowAll": "Allow All",
      "viewDetails": "View Details"
    }
  },
  "forgottenPassword": {
    "resetPassword": "Reset password",
    "enterEmailAddressAssociatedWithYourAccount": "Enter the email address associated with your account",
    "emailAddress": {
      "label": "Gebruikers-ID *",
      "placeholder": "Gebruikers-ID"
    },
    "enterValidEmail": "Please enter a valid email.",
    "passwordResetEmailSent": "An email has been sent to you with information on how to reset your password.",
    "passwordResetSuccess": "Success! You can now login using your new password."
  },
  "loginForm": {
    "forgotPassword": "Forgot password?",
    "signIn": "Sign In",
    "register": "Register",
    "dontHaveAccount": "Don’t have an account?",
    "guestCheckout": "Guest Checkout",
    "emailAddress": {
      "label": "Gebruikers-ID *",
      "placeholder": "Gebruikers-ID"
    },
    "password": {
      "label": "Password",
      "placeholder": "Password"
    },
    "wrongEmailFormat": "This is not a valid email format."
  },
  "register": {
    "confirmPassword": {
      "action": "Confirm password",
      "label": "Confirm password",
      "placeholder": "Confirm Password"
    },
    "managementInMyAccount": "Management in My Account.",
    "termsAndConditions": "Terms & Conditions",
    "signIn": "I already have an account. Sign In",
    "register": "Register",
    "confirmNewPassword": "Confirm New Password",
    "resetPassword": "Reset Password",
    "createAccount": "Create an account",
    "title": "Titel",
    "firstName": {
      "label": "Voornaam",
      "placeholder": "Voornaam"
    },
    "lastName": {
      "label": "Achternaam",
      "placeholder": "Achternaam"
    },
    "emailAddress": {
      "label": "Gebruikers-ID *",
      "placeholder": "Gebruikers-ID"
    },
    "password": {
      "label": "Password",
      "placeholder": "Password"
    },
    "newPassword": "New Password",
    "emailMarketing": "Use my personal data to receive e-mail newsletters for marketing campaigns. To change your settings, go to Consent Management in My Account.",
    "confirmThatRead": "I am confirming that I have read and agreed with the",
    "selectTitle": "Select Title",
    "passwordMinRequirements": "Password must be six characters minimum, with one uppercase letter, one number, one symbol",
    "bothPasswordMustMatch": "Both password must match",
    "titleRequired": "Title is required.",
    "postRegisterMessage": "Please log in with provided credentials."
  },
  "checkoutLogin": {
    "emailAddress": {
      "label": "Gebruikers-ID *",
      "placeholder": "Gebruikers-ID"
    },
    "confirmEmail": {
      "label": "Confirm email",
      "placeholder": "Confirm email"
    },
    "continue": "Continue",
    "emailIsRequired": "Invalid email format",
    "emailsMustMatch": "Email does not match"
  },
  "authMessages": {
    "signedOutSuccessfully": "Je bent succesvol uitgelogd."
  }
}
